import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, User, Baby, Stethoscope, Brain, Eye, Bone, Shield } from 'lucide-react';
import './Specialties.css';

const Specialties = () => {
  const navigate = useNavigate();

  const specialties = [
    {
      id: 'cardiology',
      name: 'Cardiology',
      description: 'Heart and cardiovascular health',
      icon: Heart,
      availability: 'Available Today',
      doctorCount: 47,
      color: '#dc3545'
    },
    {
      id: 'dermatology',
      name: 'Dermatology',
      description: 'Skin, hair, and nail conditions',
      icon: Shield,
      availability: 'Available Today',
      doctorCount: 32,
      color: '#28a745'
    },
    {
      id: 'pediatrics',
      name: 'Pediatrics',
      description: 'Children\'s health and development',
      icon: Baby,
      availability: 'Available Today',
      doctorCount: 28,
      color: '#ffc107'
    },
    {
      id: 'general-medicine',
      name: 'General Medicine',
      description: 'Primary care and general health',
      icon: Stethoscope,
      availability: 'Available Today',
      doctorCount: 156,
      color: '#007BFF'
    },
    {
      id: 'neurology',
      name: 'Neurology',
      description: 'Brain and nervous system disorders',
      icon: Brain,
      availability: 'Available Tomorrow',
      doctorCount: 23,
      color: '#6f42c1'
    },
    {
      id: 'ophthalmology',
      name: 'Ophthalmology',
      description: 'Eye care and vision health',
      icon: Eye,
      availability: 'Available Today',
      doctorCount: 19,
      color: '#17a2b8'
    },
    {
      id: 'orthopedics',
      name: 'Orthopedics',
      description: 'Bones, joints, and musculoskeletal',
      icon: Bone,
      availability: 'Available Today',
      doctorCount: 41,
      color: '#fd7e14'
    },
    {
      id: 'psychiatry',
      name: 'Psychiatry',
      description: 'Mental health and behavioral care',
      icon: User,
      availability: 'Available Today',
      doctorCount: 35,
      color: '#20c997'
    }
  ];

  const handleSpecialtyClick = (specialty) => {
    navigate('/find-doctors', {
      state: {
        searchCategory: 'specialty',
        searchQuery: specialty.name,
        specialty: specialty.id
      }
    });
  };

  return (
    <section className="specialties section">
      <div className="container">
        <h2 className="section-title">Popular Specialties</h2>
        <p className="section-subtitle">
          Find the right specialist for your health needs
        </p>
        
        <div className="specialty-cards">
          {specialties.map((specialty) => {
            const IconComponent = specialty.icon;
            return (
              <div
                key={specialty.id}
                className="specialty-card"
                onClick={() => handleSpecialtyClick(specialty)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleSpecialtyClick(specialty);
                  }
                }}
                aria-label={`View ${specialty.name} doctors`}
              >
                <div className="card-header">
                  <div 
                    className="specialty-icon"
                    style={{ backgroundColor: `${specialty.color}20`, color: specialty.color }}
                  >
                    <IconComponent size={32} />
                  </div>
                  <h3>{specialty.name}</h3>
                  <p className="specialty-description">{specialty.description}</p>
                </div>
                
                <div className="card-body">
                  <div className="availability-info">
                    <span 
                      className={`availability ${specialty.availability === 'Available Today' ? 'available-today' : 'available-tomorrow'}`}
                    >
                      {specialty.availability}
                    </span>
                    <span className="doctor-count">
                      {specialty.doctorCount} doctors nearby
                    </span>
                  </div>
                </div>
                
                <div className="card-footer">
                  <button className="view-doctors-btn">
                    View Doctors
                    <Stethoscope size={16} />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
        
        <div className="specialties-cta">
          <p>Don't see your specialty?</p>
          <button 
            className="btn-secondary"
            onClick={() => navigate('/find-doctors')}
          >
            <User size={20} />
            Browse All Specialties
          </button>
        </div>
      </div>
    </section>
  );
};

export default Specialties;
